import {useEffect} from "react";
// import {useMount, useSearchParam} from "react-use";
import DeviceDetector from "device-detector-js";
import {notify} from "@housebets/housebets-x-package";

import apiAuth from "app/api/auth";
import client from "app/api/client";
import {useAppSelector} from "hooks/useAppSelector";
import {loginSuccess, open2FaModal, setData2Fa} from "app/store/slices/user";
import {setInviteCode, setPromoCode, setAffilkaTag, setLoginType, setDevice} from "app/store/slices/setting";
import {LoginType} from "app/types/common";
import {useGTMEvents} from "./useGTMEvents";
import Cookies from "universal-cookie";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import {config} from 'app/config.js';
import { useSearchParam } from "app/hooks/useSearchParam";
import { useMount } from "app/hooks/useMounte";

const deviceDetector = new DeviceDetector();

let currentPrompt;

const useInitApp = () => {
    const dispatch = useDispatch();
    const promoCode = useSearchParam("promoCode");
    const inviteCode = useSearchParam("inviteCode");
    const stag = useSearchParam("stag");
    const campaign = useSearchParam("campaign");
    const {$t} = useIntl();
    const cookies = new Cookies();
    const locale = useAppSelector((state) => state.config.locale);
    const isAuth = useAppSelector((state) => state.user.isLogin);
    
    useEffect(() => {
        const value = stag || campaign;
        if (value) {
            cookies.set("affiliate_tag", value, {
                path: "/",
                maxAge: 60 * 60 * 24 * 30, // 30 days
                sameSite: "lax",
            });
        }
    }, []);

    const inviteCodeSetting = useAppSelector((state) => state.setting.inviteCode);
    const affilkaTag = useAppSelector((state) => state.setting.affilkaTag);
    const {form, registration} = useGTMEvents();

    const tgAppLogin = async (data: Record<string, string>) => {
        const res = await apiAuth.tgAppLogin({
            t_user_affilka_tag: affilkaTag,
            bonusCode: sessionStorage.getItem("bonusCode") || "",
            ...(promoCode ? {promoCode: promoCode.toString()} : {inviteCode: inviteCode ? inviteCode.toString() : "-1"}),
            ...data,
        });
        if (res.status === 200 && res.data.code === 0) {
            client.setToken(res.data.data.token);
            if (res.data.data.eventType === 0) {
                registration.complete({
                    affiliate_code: inviteCode ? inviteCode.toString() : "-1",
                    bonus_code: "",
                    currency: data.userMoneyType,
                    marketing_opt_in: false,
                    promo_code: promoCode?.toString() || "",
                    registration_method: "telegram",
                    signup_source: window.location.pathname,
                    user_id: data.userId,
                    user_type: "regular",
                });
            } else {
                form.event({
                    event: "form_submit",
                    form_id: "signin_form",
                    form_name: "Sign In Form",
                });
            }
            dispatch(loginSuccess(res.data.data));
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    useMount(() => {
        const params = new URLSearchParams(window.location.search.replace(/&amp;/g, "&"));
        if (params.get("source") === "tg") {
            sessionStorage.setItem("bonusCode", params.get("bonusCode") || "");
            const tgBotScript = document.createElement("script");
            tgBotScript.src = "https://telegram.org/js/telegram-web-app.js";
            tgBotScript.onload = () => {
                const queryString = window.Telegram?.WebApp?.initData;
                if (queryString) {
                    window.Telegram.WebApp.expand();
                    window.Telegram.WebApp.enableClosingConfirmation();

                    const regex = /(?:^|&)(\w+)=([^&]+)/g;
                    let match;
                    const values: Record<string, string> = {};
                    while ((match = regex.exec(queryString))) {
                        const key = decodeURIComponent(match[1]);
                        const value = decodeURIComponent(match[2]);
                        values[key] = value;
                    }

                    const data = {
                        auth_date: values["auth_date"],
                        hash: values["hash"],
                        first_name: JSON.parse(values["user"]).first_name,
                        id: JSON.parse(values["user"]).id,
                        appData: queryString,
                    };
                    tgAppLogin(data);
                }
            };
            document.head.appendChild(tgBotScript);
        }

        if (inviteCode) dispatch(setInviteCode(inviteCode));
        if (promoCode) dispatch(setPromoCode(promoCode));

        // Live Support
        const chatScript = document.createElement("script");
        chatScript.src = "//eu.fw-cdn.com/12549376/585604.js";
        chatScript.async = true;
        chatScript.onload = () => {
            (window as any).fwcrm.on("widget:loaded", function () {
                window.fcWidget.hide();
                window.fcWidget.on("widget:closed", function () {
                    window.fcWidget.hide();
                });
            });
        };
        document.head.appendChild(chatScript);
    });

    useEffect(() => {
        const value = stag || campaign;

        if (value) {
            dispatch(setAffilkaTag(value));
        }
    }, [stag, campaign]);

    const handleCredentialResponse = async (response: any) => {
        const data = {
            ...(promoCode ? {promoCode: promoCode.toString()} : {inviteCode: inviteCodeSetting.toString() || "-1"}),
            credential: response.credential,
            affilkaTag: stag || campaign,
        };
        const res = await apiAuth.googleLogin(data);
        console.log('googleLogin response', res);
        if (res.data.code === 13) {
            dispatch(
                setData2Fa({
                    type: "googleLogin",
                    data: data,
                }),
            );
            dispatch(open2FaModal());
            return;
        }
        if (res.status === 200 && res.data.code === 0) {
            dispatch(loginSuccess(res.data.data));
            dispatch(setLoginType(LoginType.HIDE));
            if (res.data.data.eventType === 0) {
                registration.complete({
                    affiliate_code: affilkaTag ? affilkaTag : "-1",
                    bonus_code: "",
                    currency: res.data.code.userMoneyType,
                    marketing_opt_in: false,
                    promo_code: promoCode?.toString() || "",
                    registration_method: "google",
                    signup_source: window.location.pathname,
                    user_id: res.data.code.userId,
                    user_type: "regular",
                });
            } else {
                form.event({
                    event: "form_submit",
                    form_id: "signin_form",
                    form_name: "Sign In Form",
                });
            }
            // showLiveChat();
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    useEffect(() => {
        const loadGoogleSignInLibrary = () => {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = "https://accounts.google.com/gsi/client";
                script.async = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        };

        loadGoogleSignInLibrary().then(() => {
            if (window.google) {
                if (currentPrompt) {
                    currentPrompt.cancel();
                }
                window.google.accounts.id.initialize({
                    client_id: config.google_auth_client_id,
                    callback: handleCredentialResponse,
                    itp_support: true,                    
                    cancel_on_tap_outside: true,
                    auto_select: false,                    
                    context: 'signup',
                    locale  
                });
                const googleLoginWrapper = document.createElement("div");
                googleLoginWrapper.style.display = "none";
                googleLoginWrapper.classList.add("custom-google-button");
                document.body.appendChild(googleLoginWrapper);
                window.google.accounts.id.renderButton(googleLoginWrapper, {theme: "filled_blue"});
                const googleLoginWrapperButton: HTMLElement | null = googleLoginWrapper.querySelector("div[role=button]");
                window.handleGoogleLogin = () => {
                    if (googleLoginWrapperButton) {
                        googleLoginWrapperButton.click();
                    }
                };
                currentPrompt = window.google.accounts.id;
                if (!isAuth) {
                    window.google.accounts.id.prompt((notification) => {
                        if (notification.isNotDisplayed()) {
                            console.log("Prompt not displayed:", notification.getNotDisplayedReason());
                        } else if (notification.isSkippedMoment()) {
                            console.log("Prompt skipped:", notification.getSkippedReason());
                        } else if (notification.isDismissedMoment()) {
                            console.log("Prompt dismissed:", notification.getDismissedReason());
                        }
                    });
                }
            }
        });
    }, [locale, isAuth]);

    useEffect(() => {
        dispatch(setDevice(deviceDetector.parse(window.navigator.userAgent)));
    }, []);

    return {};
};

export default useInitApp;
